/**
 *
 * Asynchronously loads the component for Anagrafica
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Anagrafica/Loadable.js